import Contact from '../../modules/Contact/Contact';

function ContactLayout() {
  return (
    <div>
      <Contact />
    </div>
  );
}

export default ContactLayout;

